// import { IHttpService } from 'repository/IHttpService';
// import { IUserService as IUserRepository } from './IAuthService';

export class ViewRepository implements IViewRepository {

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getViews(): Promise<View[]> {
        const response = await this.httpService.get<Data<View[]>>('/v1/view');
        const data = response.data.map((view: View) => ({
            ...view,
            id: view.view_id
        }));
        return data;
    }
}
